module.exports = __webpack_public_path__ + "img/green_080.1c7409d9.png";